import { useState, type FormEvent } from 'react';
import { ApiClientError } from '../lib/api.js';
import { useAuth } from '../lib/auth.js';

export function LoginPage() {
  const { login, bootstrap } = useAuth();
  const [mode, setMode] = useState<'login' | 'bootstrap'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === 'bootstrap') {
        await bootstrap({ email, password });
      } else {
        await login({ email, password });
      }
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : 'Something went wrong');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={onSubmit}>
        <h1>Commerce Product Hub</h1>
        <p className="muted">
          {mode === 'bootstrap' ? 'Create the owner account' : 'Sign in to continue'}
        </p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete={mode === 'bootstrap' ? 'new-password' : 'current-password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={mode === 'bootstrap' ? 12 : undefined}
        />

        {error && (
          <p role="alert" className="form-error">
            {error}
          </p>
        )}

        <button type="submit" disabled={busy}>
          {busy ? 'Please wait…' : mode === 'bootstrap' ? 'Create owner' : 'Sign in'}
        </button>

        <button
          type="button"
          className="link-button"
          onClick={() => setMode(mode === 'login' ? 'bootstrap' : 'login')}
        >
          {mode === 'login' ? 'First-time setup? Create the owner account' : 'Back to sign in'}
        </button>
      </form>
    </div>
  );
}
